import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=afaa64fe&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=afaa64fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaa64fe",
  null
  
)

export default component.exports